import { render } from "./Token.vue?vue&type=template&id=14a3904f&scoped=true&ts=true"
import script from "./Token.vue?vue&type=script&lang=ts"
export * from "./Token.vue?vue&type=script&lang=ts"

import "./Token.vue?vue&type=style&index=0&id=14a3904f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a3904f"]])

export default __exports__